import React from 'react';

import { Button } from '@xing-com/button';
import { IconArrowRight } from '@xing-com/icons';
import { Headline, BodyCopy } from '@xing-com/typography';

type FlagContentType = {
  headerCopy: string;
  bodyCopy: string[];
  ctaCopy: string | undefined;
  ctaUrl: string;
  /**
   * Control if background should be premium green
   */
  premiumTheme: boolean;
};

export const FlagContent: React.FC<FlagContentType> = ({
  headerCopy,
  bodyCopy,
  ctaCopy,
  ctaUrl,
  premiumTheme,
}) => {
  return (
    <React.Fragment>
      <Headline size="medium">{headerCopy}</Headline>

      {bodyCopy.map((copy, index) => (
        <BodyCopy key={index} size="small">
          {/* eslint-disable-next-line react/no-danger */}
          <span dangerouslySetInnerHTML={{ __html: copy }} />
        </BodyCopy>
      ))}

      {ctaCopy ? (
        <Button
          href={ctaUrl}
          variant={premiumTheme ? 'premium' : 'tertiary'}
          size="small"
          icon={premiumTheme ? IconArrowRight : undefined}
          data-testid="user-flag-cta"
        >
          {ctaCopy}
        </Button>
      ) : null}
    </React.Fragment>
  );
};
